import { Statsig } from '../../statsig/StatsigProvider';
import { ExperimentLayers } from '../../statsig/experiments';
import toast from '../../toasts/toasts';
import { isArcBrowser } from '../../utils';
import { SYSTEM_NOTIFICATIONS_PERMISSION_USER_GESTURE_PROMPT_TOAST_KEY } from './constants';

/**
 * Whether the user is in the Statsig experiment that enables system
 * notifications in the admission flow.
 *
 * The Arc browser is also avoided because its on-click behavior opens a new tab
 * to the provider login page.
 */
export function areSystemNotificationsEnabled() {
  if (isArcBrowser()) return false; // avoids exposures

  // Remove the experiement post-release but keep the above check for Arc
  // browser
  const [admission, { systemNotificationsAreEnabled }] = ExperimentLayers.Admission;
  return Statsig.getLayer(admission).get<boolean>(systemNotificationsAreEnabled, false);
}

/**
 * Hide the toast prompting the user to click a button to request system
 * notification permissions.
 */
export function hideSystemNotificationsPermissionUserGesturePromptToast() {
  toast.closeByKey(SYSTEM_NOTIFICATIONS_PERMISSION_USER_GESTURE_PROMPT_TOAST_KEY);
}
